import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { AuthService } from './services/auth.service';
import { map, take, switchMap } from 'rxjs/operators';
import { of, from } from 'rxjs';

const redirectLoggedInToShell = () => {
  const authService = inject(AuthService);
  return () => {
    return authService.user$.pipe(
      take(1),
      map(user => {
        if (user) {
      return ['/'];
    }
    return true;
      })
    );
  };
};

const redirectUnauthorisedOrUnverifiedUser = () => {
  const authService = inject(AuthService);
  return () => {
    return authService.user$.pipe(
      take(1),
      switchMap(user => {
        if (!user) {
          return of(['/login']);
    }
        return from(authService.isEmailVerified()).pipe(
          map(isVerified => {
    if (!isVerified) {
      return ['/login'];
    }
        return true;
          })
        );
      })
    );
  };
};

export const routes: Routes = [
  { 
    path: 'login', 
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    canActivate: [redirectLoggedInToShell]
  },
  { 
    path: 'terms', 
    loadComponent: () => import('./terms/terms.component').then(m => m.TermsComponent)
  },
  { 
    path: 'privacy', 
    loadComponent: () => import('./privacy/privacy.component').then(m => m.PrivacyComponent)
  },
  { 
    path: '',
    loadChildren: () => import('./shell/shell.module').then(m => m.ShellModule),
    canActivate: [redirectUnauthorisedOrUnverifiedUser]
  },
  {
    path: '**',
    loadComponent: () => import('./components/not-found/not-found.component')
      .then(m => m.NotFoundComponent)
  }
]; 